import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { HttpUtilService, HttpResponse } from "../http-util.service";
import {
  model,
  active,
  ApiResult,
  UploadedFile,
  AddSpecialPrice,
} from "src/app/models/sales/special-price-list-master";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class SpecialPriceListMasterService {
  constructor(
    private http: HttpUtilService,
    private httpClient: HttpClient,
  ) {}

  GetAll(): Observable<HttpResponse<model[]>> {
    return this.http.get("SpecialPriceListMasterService.asmx/GetAll");
  }

  Delete(items: model[]): Observable<HttpResponse<ApiResult>> {
    return this.http.post(
      "SpecialPriceListMasterService.asmx/Delete",
      {
        items,
      },
    );
  }

  GetBasicActiveModelList(): Observable<HttpResponse<active[]>> {
    return this.http.get(
      "ModelSpecificationService.asmx/GetBasicActiveModelList",
    );
  }

  GetDetails(id: string): Observable<HttpResponse<model>> {
    return this.http.get(
      "SpecialPriceListMasterService.asmx/GetDetails",
      {
        params: { id },
      },
    );
  }

  Update(model: model): Observable<HttpResponse<ApiResult>> {
    return this.http.post(
      "SpecialPriceListMasterService.asmx/Update",
      {
        model,
      },
    );
  }

  Add(model: AddSpecialPrice): Observable<HttpResponse<ApiResult<model>>> {
    return this.http.post("SpecialPriceListMasterService.asmx/Add", {
      model,
    });
  }

  GetAllFiles(): Observable<HttpResponse<any[]>> {
    return this.http.get(
      "SpecialPriceListMasterService.asmx/GetAllFiles",
    );
  }

  UploadFiles(file: File): Observable<UploadedFile> {
    const formData = new FormData();
    formData.append("file", file, file.name);
    formData.append("docType", "SpecialPriceList");

    // UploadFiles.ashx returns a raw JSON object, not an ASMX `{ d: ... }`
    // response, so it must not go through HttpUtilService.massageResponse.
    return this.httpClient.post<UploadedFile>(
      `${environment.KAPS_API_BACKEND_URL}UploadFiles.ashx`,
      formData,
    );
  }
}
